import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * tailwind-merge tiene que conocer la escala tipográfica propia (@theme en styles.css).
 * Si no, toma `text-cuerpo` como un COLOR y borra `text-texto-invertido` (o al revés).
 * Tamaño nuevo en @theme → agregarlo acá.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ["chico", "cuerpo", "subtitulo", "titulo", "cifra", "pantalla"],
      radius: ["control", "tarjeta"],
      shadow: ["tarjeta", "flotante"],
    },
  },
});

/** Combina clases de Tailwind resolviendo conflictos (la última gana). */
export function cn(...clases: ClassValue[]): string {
  return twMerge(clsx(clases));
}
